// @flow
import { categorySettingsActions } from "./categorySettingsActionCreator";

const initialState = {
  groupTypes: {
    isLoading: false,
    isLoaded: false,
    data: []
  },
  ticketTypes: {
    isLoading: false,
    isLoaded: false,
    data: []
  },
  category: {
    isLoading: false,
    isLoaded: false,
    data: null,
    allowAPIcall: true
  },
  issue: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  delete: {
    isLoading: false,
    isLoaded: false,
    data: null
  }
};

const categorySettingsReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case categorySettingsActions.GET_GROUP_TYPES_BY_BU: {
      return Object.assign({}, state, {
        groupTypes: action.payload
      });
    }
    case categorySettingsActions.GET_TICKET_TYPES_BY_BU_AND_GROUP_TYPE: {
      return Object.assign({}, state, {
        ticketTypes: action.payload
      });
    }
    case categorySettingsActions.CREATE_CATEGORY: {
      return Object.assign({}, state, { category: action.payload });
    }
    case categorySettingsActions.CREATE_ISSUE: {
      return Object.assign({}, state, { issue: action.payload });
    }
    case categorySettingsActions.DELETE_ISSUE: {
      return Object.assign({}, state, {
        delete: action.payload
      });
    }
    default: {
      return state;
    }
  }
};

export default categorySettingsReducer;



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/categorySettings/categorySettingsRedux/categorySettingsReducer.js